export const AIChatGreen = {
    // 模块配置
 // AIChat - banner
 "--theme-AIChat-banner-title-color": "white",
 "--theme-AIChat-banner-des-color": "white",
 "--theme-AIChat-banner-btn-color": "white",
 "--theme-AIChat-banner-btn-bg": "#1BDA7C",
 // AIChat - explain
 "--theme-AIChat-explain-bg": "white",
 "--theme-AIChat-explain-inner-bg": "white",
 "--theme-AIChat-explain-item-shadow": "none",
 "--theme-AIChat-explain-inner-bg-hover": "#17A18A",
 // AIChat - step
 "--theme-AIChat-step-bg": "#1BDA7C",
 "--theme-AIChat-step-inner-bg": "white",
 "--theme-AIChat-step-inner-bg-hover": "#01002C",
 "--theme-AIChat-step-title-color": "#01002C",
 "--theme-AIChat-step-inner-title-color": "#01002C",
 "--theme-AIChat-step-inner-desc-color": "#252325",
 "--theme-AIChat-step-inner-title-color-hover": "#1BDA7C",
 "--theme-AIChat-step-inner-desc-color-hover": "white",
 "--theme-AIChat-step-radius": "10px",
 // AIChat - price
 "--theme-AIChat-price-btn-bg": "#FCC133",
 "--theme-AIChat-price-btn-color": "#252325",
 "--theme-AIChat-price-btn-color-hover": "#252325",
 "--theme-AIChat-price-btn-bg-hover": "#FCC133",
 "--theme-AIChat-price-text-color": "#252325",
 "--theme-AIChat-price-text-color-hover": "#FCC133",
 "--theme-AIChat-price-ul-text-align": "left",
 "--theme-AIChat-price-item-bg": "white",
 "--theme-AIChat-price-item-bg-hover": "#01002C",
 "--theme-AIChat-price-item-border-radius": "10px",
 "--theme-AIChat-price-light": "#021054",
 "--theme-AIChat-price-deep": "#0A0858",
 // AIChat - question
 "--theme-AIChat-question-bg": "#F6F6F6",
 // AIChat - comment
 "--theme-AIChat-comment-border-radius": "20px",
 "--theme-AIChat-comment-item-bg-hover": "#01002C",

}